import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Repository } from '@model/Repository';
import { environment } from '@env/environment';
import { Paginate } from '@model/Paginate';
import { Project } from '@model/Project';

@Injectable({
  providedIn: 'root'
})
export class RepositoriesService {

  constructor(private http: HttpClient) {}

  paginate(per_page: number = 20, page: number = 1, param: string = '', is_author: boolean = true): Observable<Paginate<Repository>> {
    return this.http.get<Paginate<Repository>>(`${environment.base_url}/repositories?page=${page}&per_page=${per_page}&param=${param}&is_author=${is_author}`);
  }

  paginateByProjects(repositoryId: number, per_page: number = 20, page: number = 1, param: string = ''): Observable<Paginate<Project>> {
    return this.http.get<Paginate<Project>>(`${environment.base_url}/repositories/${repositoryId}/projects?page=${page}&per_page=${per_page}&param=${param}`);
  }

  store(repository: Repository): Observable<Repository> {
    return this.http.post<Repository>(`${environment.base_url}/repositories`, repository);
  }

  update(id: number, repository: Repository): Observable<Repository> {
    return this.http.put<Repository>(`${environment.base_url}/repositories/${id}`, repository);
  }

  delete(form: any): Observable<any> {
    return this.http.post(`${environment.base_url}/repositories/delete`, form);
  }

  projectByCountProject(repositoryId: number, page: number = 1): Observable<Paginate<Project>> {
    return this.http.get<Paginate<Project>>(`${environment.base_url}/repositories/${repositoryId}/projects?page=${page}}`);
  }

  getRepositories(per_page: number = 20, page: number = 1, filter: string, search: string, isAuthor = true): Observable<any> {
    return this.http.get(`${environment.base_url}/repositories/get_all_repositories?filter=${filter}&search=${search}&is_author=${isAuthor}&per_page=${per_page}`);
  }
}
